import api from '../../api/client';
import React, { useEffect, useState } from 'react'
import { useSetRecoilState } from 'recoil'
import { useRecoilState } from 'recoil'
import { Box } from '@material-ui/core'
import { getAccessToken } from '../../api/authenticate'
import DepartmentInfo from '../../components/department/DepartmentInfo'
import FileUpload from '../../components/department/FileUpload'
import DepartmentManagers from '../../components/department/DepartmentManagers'
import Layout from '../../components/layout/Layout'
import { loadingState, loggedInState, userInfoState } from '../../recoil/atoms'


const DepartmentDashboard = () => {
    const [userInfo, setUserInfo] = useRecoilState(userInfoState)
    const setLoggedIn = useSetRecoilState(loggedInState)
    const [refreshInterval, setRefreshInterval] = useState(0)
    const setLoading = useSetRecoilState(loadingState)
    const uploadFile = async file => {
        const formData = new FormData()
        formData.append('file', file)
        setLoading(true)
        const response = await api.post('contracts/upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        if (response.status === 202) {
            let newUserInfo = { ...userInfo }
            newUserInfo['is_processing'] = true
            setUserInfo(newUserInfo)
            setRefreshInterval(10000)
        }
        setLoading(false)
    }
    useEffect(() => {
        if (userInfo['is_processing'])
            setRefreshInterval(10000)
        if (refreshInterval && refreshInterval > 0) {
            setInterval(() => {
                getAccessToken(setLoggedIn, setUserInfo)
            }, refreshInterval)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshInterval])
    return (
        <Layout>
            <DepartmentInfo
                name={userInfo.name}
                nationalCode={userInfo.national_code}
                isProcessing={userInfo.is_processing}
                lastSuccessfulUpload={userInfo.last_successful_upload}
                deptId={userInfo.id}
            />
            <FileUpload
                upload={uploadFile}
                disabled={userInfo.is_processing}
                fileTypes={['.zip']}
            />
            <Box style={{ marginTop: 20 }}>
                <DepartmentManagers />
            </Box>
        </Layout >
    )
}

export default DepartmentDashboard